import InputField from "components/fields/InputField";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { _createOrganization } from "Services/api";
import { useNavigate } from "react-router-dom";
import {
  OrganizationFormFieldsName,
  organizationFormDefaultValues,
  organizationFormSchema,
} from "constants/react-hook-form";
import { getStoredUser, storeAdminSession } from "utils/session";

export default function Organization() {
  const [apiResError, setApiResError] = useState();
  const navigate = useNavigate();

  const { control, handleSubmit } = useForm({
    resolver: zodResolver(organizationFormSchema),
    defaultValues: organizationFormDefaultValues,
  });

  const handleOrganization = async (data) => {
    const accessToken = sessionStorage.getItem("VendorToken");
    try {
      const body = {
        name: data[OrganizationFormFieldsName.NAME],
        website: data[OrganizationFormFieldsName.WEBSITE],
        description: data[OrganizationFormFieldsName.DESCRIPTION],
      };
      const response = await _createOrganization({ body, accessToken });
      if (response.status) {
        const responseData = response?.data?.data || response?.data || {};
        const currentUser = getStoredUser();
        storeAdminSession({
          ...currentUser,
          ...(responseData?.user || {}),
          access_token: responseData?.access_token || responseData?.token,
          organization_id: responseData?.organization?.id || responseData?.organization?.org_id,
          account_status: "pending",
          approval_required: true,
          is_active: false,
        });

        navigate("/admin/pending-approval");
      }
    } catch (error) {
      console.log(error);
      setApiResError(error?.response?.data?.message);
    }
  };

  return (
    <div className="mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <form
        className="w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]"
        onSubmit={handleSubmit(handleOrganization)}
        noValidate
      >
        <h4 className="mb-2.5 mt-5 text-4xl font-bold text-navy-700 dark:text-white">
          Organization Creation
        </h4>
        <div className="text-red-600">{apiResError}</div>
        <InputField
          control={control}
          name={OrganizationFormFieldsName.NAME}
          variant="auth"
          extra="mb-3"
          label="Organization Name*"
          placeholder="Enter your organization name"
          id="name"
          type="text"
        />
        <InputField
          control={control}
          name={OrganizationFormFieldsName.WEBSITE}
          variant="auth"
          extra="mb-3"
          label="Website*"
          placeholder="Enter your website url"
          id="website"
          type="text"
        />
        <InputField
          control={control}
          name={OrganizationFormFieldsName.DESCRIPTION}
          variant="auth"
          extra="mb-3"
          label="Description*"
          placeholder="Enter about your website"
          id="description"
          type="text"
        />
        {/* <div className="mb-4 flex items-center justify-between px-2">
          <div className="flex items-center">
            <Checkbox />
            <p className="ml-2 text-sm font-medium text-navy-700 dark:text-white">
              Keep me logged In
            </p>
          </div>
          <a
            className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            href=" "
          >
            Forgot Password?
          </a>
        </div> */}
        <button
          type="submit"
          className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
        >
          Sign Up
        </button>
        {/* <div className="mt-4">
          <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
            Not registered yet?
          </span>
          <a
            href=" "
            className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
          >
            Create an account
          </a>
        </div> */}
      </form>
    </div>
  );
}
